import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Aggregate_Sum_getInstancegzwfj16tyqqb as Aggregate_Sum_getInstance } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Aggregate.mjs';
import {
  Companion_getInstance1cdih9ztewhpv as Companion_getInstance,
  Projecto73xqbcrzskm as Project,
  LineItem2rt64afaiyloc as LineItem,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_clientDeposits3iceuvgspasbp as get_clientDeposits,
  get_contractorPayments1uble8nvvhe26 as get_contractorPayments,
  get_contractor2weo1umt9id6t as get_contractor,
  get_state23zbf4that7g as get_state,
  get_nameo9a32lyl7xbh as get_name,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import { AggregateQuery2zg9ab3akfubi as AggregateQuery } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/GroupCountQuery.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__div_impl_3meibk3mb2kbjjy06qs as MonetaryValue__div_impl_3meibk,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../selectedContractor.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_section1qyzr1npzel2z as get_section } from '../../theming/sections.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from './ContractorProject.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
  smallBody2trfy14zwtona as smallBody,
  title1ahgushtajx2d as title,
} from '../../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { ProjectStateSemanticzawrm52z9108 as ProjectStateSemantic } from '../../theming/states.mjs';
import {
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  align1ejncrrer3meh as align,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  get_padded3m3frjnjujncx as get_padded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Canvas2ofr7h6unhudb as Canvas } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Canvas.commonHtml.mjs';
import { ProgressDelegate2saexiliay2do as ProgressDelegate } from '../../components/ProgressDelegate.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  listOfvhqybd2zx248 as listOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  MemberRole_Admin_getInstance3iiznt2spfc6m as MemberRole_Admin_getInstance,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  ProjectState_Creating_getInstancegu71uom71mst as ProjectState_Creating_getInstance,
  ProjectState_Invited_getInstancendchtgzjx7u0 as ProjectState_Invited_getInstance,
  ProjectState_WaitingApproval_getInstance1ditr18fxhnoh as ProjectState_WaitingApproval_getInstance,
  ProjectState_Complete_getInstance2ov0hpwbwxocu as ProjectState_Complete_getInstance,
  ProjectState_Warranty_getInstance3k7ift69kuu7o as ProjectState_Warranty_getInstance,
  ProjectState_Terminated_getInstancedn60ew509y4p as ProjectState_Terminated_getInstance,
  ProjectState_Cancelled_getInstanceoirlccakusgk as ProjectState_Cancelled_getInstance,
  ProjectState_Abandoned_getInstance19b47j86nick as ProjectState_Abandoned_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  contains2gm06f5aa19ov as contains,
  getOrNull1go7ef9ldk0df as getOrNull,
  toList3jhuyej2anx2q as toList,
  sortedWith2csnbbb21k0lg as sortedWith,
  chunked1umgsyuj0x9u1 as chunked,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  eq1298m2cje971u as eq,
  xDataClassPathNotInSet2lprzz67ddi7c as xDataClassPathNotInSet,
  inside3oxyfk5qky4sm as inside,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { And3abx79zpqd7r8 as And } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { listOf1jh22dvmctj1r as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ContractorProjects2hltgp2s6pm9i as ContractorProjects } from './ContractorProjects.mjs';
import { ContractorPayments3j77ex8prycqi as ContractorPayments } from './ContractorPayments.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ClientDashboard2uxyaz2oxv2st as ClientDashboard } from '../client/ClientDashboard.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { generalToDos3v1z2jqg8nvlm as generalToDos } from '../common/GeneralToDos.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { get_viewIsWide3s4g60a9e0192 as get_viewIsWide } from '../../components/nav/crowpay.mjs';
import { CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  get_project15zbqkhtwq5i6 as get_project,
  get_cancelled2dthnu39zs2ql as get_cancelled,
} from '../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  get_requiredMembershipRole2ywu1e77bwer8 as get_requiredMembershipRole,
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from './IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfw().rfg_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ojg_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = tmp_0.wfp(tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2.toString();
}
function *_generator_invoke__zhh2q8_0($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.pjg_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp)
    return null;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.vfw().rfg_1;
  var tmp_2 = Aggregate_Sum_getInstance();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.qjg_1;
  var tmp_3 = await_0(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = tmp_3;
  // Inline function 'com.crowpay.path' call
  Companion_getInstance();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_5 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$3 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
  var tmp$ret$5 = new (DataClassPathSelf())(tmp$ret$3);
  var tmp_6 = tmp_1.xfp(new (AggregateQuery())(tmp_2, tmp_4, get_clientDeposits(tmp$ret$5)), $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var deposits = tmp_6;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = get_session();
  var tmp_7 = await_0(this_3, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp_8 = tmp_7.vfw().rfg_1;
  var tmp_9 = Aggregate_Sum_getInstance();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.qjg_1;
  var tmp_10 = await_0(this_4, $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  var tmp_11 = tmp_10;
  // Inline function 'com.crowpay.path' call
  Companion_getInstance();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_12 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$8 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
  var tmp$ret$10 = new (DataClassPathSelf())(tmp$ret$8);
  var tmp_13 = tmp_8.xfp(new (AggregateQuery())(tmp_9, tmp_11, get_contractorPayments(tmp$ret$10)), $completion);
  if (tmp_13 === get_COROUTINE_SUSPENDED())
    tmp_13 = yield tmp_13;
  var payments = tmp_13;
  var tmp_14;
  if (deposits == null) {
    tmp_14 = null;
  } else {
    tmp_14 = deposits - (payments == null ? 0.0 : payments);
  }
  var tmp2_safe_receiver = tmp_14;
  var tmp_15 = tmp2_safe_receiver == null ? null : Companion_instance.u9s(tmp2_safe_receiver);
  return tmp_15 == null ? null : new (MonetaryValue())(tmp_15);
}
function *_generator_invoke__zhh2q8_1($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.rjg_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp)
    return null;
  var tmp_0;
  try {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_session();
    var tmp_1 = await_0(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = tmp_1.vfw().off_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_notNullContractor();
    var tmp_3 = await_0(this_2, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp$ret$2 = tmp_3;
    var tmp_4 = tmp_2.tfi(tmp$ret$2, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp_0 = tmp_4.p9v_1;
  } catch ($p) {
    var tmp_5;
    if ($p instanceof Exception()) {
      var e = $p;
      tmp_5 = null;
    } else {
      throw $p;
    }
    tmp_0 = tmp_5;
  }
  var tmp_6 = tmp_0;
  return tmp_6 == null ? null : new (MonetaryValue())(tmp_6);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.sjg_1 = function_0;
      }
      wi(a, b) {
        return this.sjg_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.sjg_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function renderMainContent$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderSnapshot_mg9uce(_this__u8e3s4, data) {
  if (data == null) {
    var tmp = _this__u8e3s4.kbb(get_section(_this__u8e3s4), get_expanding(_this__u8e3s4));
    // Inline function 'com.lightningkite.kiteui.views.direct.link' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (Link())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.gbb(p, view);
    view.gba(get_AppDimensions().zg1_1);
    view.bb9(get_AppDimensions().zg1_1);
    view.zb8(false);
    _this__u8e3s4.hbb(p, view);
    _this__u8e3s4.lbb(tmp, view);
    return Unit_instance;
  }
  var project = data.e2();
  var items = data.f2();
  var tmp_0 = _this__u8e3s4.kbb(get_section(_this__u8e3s4), get_expanding(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Link())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs_0 = _this__u8e3s4.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? _this__u8e3s4 : tmp0_elvis_lhs_0;
  _this__u8e3s4.gbb(p_0, view_0);
  view_0.gba(get_AppDimensions().zg1_1);
  view_0.bb9(get_AppDimensions().zg1_1);
  view_0.kbw(() => new (ContractorProject())(project.v7a_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(true);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = project.b7b_1;
  var tmp_1 = view_2.vb5_1;
  var tmp_2;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_2 = '\xA0';
  } else {
    tmp_2 = value;
  }
  tmp_1.hbu(tmp_2);
  view_1.hbb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.gbb(p_3, view_3);
  view_3.zbm(false);
  view_3.bb9(get_rem(0.5));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_3 = view_4.vb5_1;
  var tmp_4;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('State:') === 0) {
    tmp_4 = '\xA0';
  } else {
    tmp_4 = 'State:';
  }
  tmp_3.hbu(tmp_4);
  view_3.hbb(p_4, view_4);
  var tmp_5 = view_3.kbb(get_expanding(view_3), view_3.jbb(ProjectStateSemantic().eh1(project.u7b_1)));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_3.pc());
  var tmp0_elvis_lhs_5 = view_3.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
  view_3.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(BodySemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = project.u7b_1.u9b_1;
  var tmp_6 = view_5.vb5_1;
  var tmp_7;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_7 = '\xA0';
  } else {
    tmp_7 = value_0;
  }
  tmp_6.hbu(tmp_7);
  view_3.hbb(p_5, view_5);
  view_3.lbb(tmp_5, view_5);
  view_1.hbb(p_3, view_3);
  if (!(project.e7c_1 == null)) {
    align(view_1, Align_Start_getInstance(), Align_Center_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_6 = view_1.ebb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_1 : tmp0_elvis_lhs_6;
    view_1.gbb(p_6, view_6);
    view_6.zbm(true);
    view_6.bb9(get_px(0));
    body(view_6, 'Work Item Progress');
    var tmp$ret$28;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp_8;
      if (isInterface(items, Collection())) {
        tmp_8 = items.i1();
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp$ret$28 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s = items.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (!(element.w6k_1 == null)) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$28 = count;
    }
    var done = tmp$ret$28;
    var tmp_9 = sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(1));
    // Inline function 'com.lightningkite.kiteui.views.direct.canvas' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Canvas())(view_6.pc());
    var tmp0_elvis_lhs_7 = view_6.ebb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
    view_6.gbb(p_7, view_7);
    view_7.tbi(ProgressDelegate().yga(AppColors_getInstance().ffz_1.zg9_1, done / items.p1()));
    view_6.hbb(p_7, view_7);
    view_6.lbb(tmp_9, view_7);
    smallBody(view_6, '' + done + '/' + items.p1() + ' work items met');
    view_1.hbb(p_6, view_6);
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.contains' call
  } else {
    align(view_1, Align_Start_getInstance(), Align_Center_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_8 = view_1.ebb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_1 : tmp0_elvis_lhs_8;
    view_1.gbb(p_8, view_8);
    view_8.zbm(true);
    view_8.bb9(get_px(0));
    body(view_8, 'Payment Progress');
    var tmp_10 = sizeConstraints(view_8, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(1));
    // Inline function 'com.lightningkite.kiteui.views.direct.canvas' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (Canvas())(view_8.pc());
    var tmp0_elvis_lhs_9 = view_8.ebb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
    view_8.gbb(p_9, view_9);
    view_9.tbi(ProgressDelegate().yga(AppColors_getInstance().ffz_1.zg9_1, MonetaryValue__div_impl_3meibk(project.u97(), project.w7b_1)));
    view_8.hbb(p_9, view_9);
    view_8.lbb(tmp_10, view_9);
    smallBody(view_8, MonetaryValue__toString_impl_xslc77(project.u97()) + ' / ' + MonetaryValue__toString_impl_xslc77(project.w7b_1));
    view_1.hbb(p_8, view_8);
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.contains' call
  }
  view_0.hbb(p_1, view_1);
  _this__u8e3s4.hbb(p_0, view_0);
  _this__u8e3s4.lbb(tmp_0, view_0);
}
function ContractorDashboard$renderMainContent$lambda($this$remember) {
  var tmp = setOf([MemberRole_Admin_getInstance(), MemberRole_Manager_getInstance()]);
  var tmp0_safe_receiver = $this$remember.daj($this$remember.daj(get_session()).rfw_1).k88_1;
  return contains(tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1);
}
function ContractorDashboard$renderMainContent$lambda_0($this$remember) {
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$0);
  var tmp_0 = eq(get_contractor(it), $this$remember.daj(get_notNullContractor()));
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it_0 = new (DataClassPathSelf())(tmp$ret$5);
  var tmp$ret$9 = xDataClassPathNotInSet(get_state(it_0), setOf([ProjectState_Creating_getInstance(), ProjectState_Invited_getInstance(), ProjectState_WaitingApproval_getInstance(), ProjectState_Complete_getInstance(), ProjectState_Warranty_getInstance(), ProjectState_Terminated_getInstance(), ProjectState_Cancelled_getInstance(), ProjectState_Abandoned_getInstance()]));
  return And().u3q(listOf_0([tmp_0, tmp$ret$9]));
}
var ContractorDashboard$renderMainContent$slambdaClass;
function ContractorDashboard$renderMainContent$slambda() {
  if (ContractorDashboard$renderMainContent$slambdaClass === VOID) {
    class $ {
      constructor($projectCondition) {
        this.ojg_1 = $projectCondition;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorDashboard$renderMainContent$slambdaClass = $;
  }
  return ContractorDashboard$renderMainContent$slambdaClass;
}
function ContractorDashboard$renderMainContent$slambda_0($projectCondition) {
  var i = new (ContractorDashboard$renderMainContent$slambda())($projectCondition);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var ContractorDashboard$renderMainContent$slambdaClass_0;
function ContractorDashboard$renderMainContent$slambda_1() {
  if (ContractorDashboard$renderMainContent$slambdaClass_0 === VOID) {
    class $ {
      constructor($isManager, $projectCondition) {
        this.pjg_1 = $isManager;
        this.qjg_1 = $projectCondition;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorDashboard$renderMainContent$slambdaClass_0 = $;
  }
  return ContractorDashboard$renderMainContent$slambdaClass_0;
}
function ContractorDashboard$renderMainContent$slambda_2($isManager, $projectCondition) {
  var i = new (ContractorDashboard$renderMainContent$slambda_1())($isManager, $projectCondition);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var ContractorDashboard$renderMainContent$slambdaClass_1;
function ContractorDashboard$renderMainContent$slambda_3() {
  if (ContractorDashboard$renderMainContent$slambdaClass_1 === VOID) {
    class $ {
      constructor($isManager) {
        this.rjg_1 = $isManager;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorDashboard$renderMainContent$slambdaClass_1 = $;
  }
  return ContractorDashboard$renderMainContent$slambdaClass_1;
}
function ContractorDashboard$renderMainContent$slambda_4($isManager) {
  var i = new (ContractorDashboard$renderMainContent$slambda_3())($isManager);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ContractorDashboard$renderMainContent$lambda_1() {
  return new (ContractorProjects())();
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ContractorDashboard$renderMainContent$lambda_2() {
  return new (ContractorPayments())();
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ContractorDashboard$renderMainContent$lambda_3() {
  return new (ContractorPayments())();
}
function ContractorDashboard$renderMainContent$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.e2().u7b_1.b4_1;
  var tmp0 = a.f2();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp_0;
    if (isInterface(tmp0, Collection())) {
      tmp_0 = tmp0.i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$0 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!(element.w6k_1 == null)) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$0 = count;
  }
  var tmp_1 = tmp + tmp$ret$0 / a.f2().p1();
  var tmp_2 = b.e2().u7b_1.b4_1;
  var tmp0_0 = b.f2();
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.count' call
    var tmp_3;
    if (isInterface(tmp0_0, Collection())) {
      tmp_3 = tmp0_0.i1();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp$ret$3 = 0;
      break $l$block_0;
    }
    var count_0 = 0;
    var _iterator__ex2g4s_0 = tmp0_0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      if (!(element_0.w6k_1 == null)) {
        count_0 = count_0 + 1 | 0;
        checkCountOverflow(count_0);
      }
    }
    tmp$ret$3 = count_0;
  }
  var tmp$ret$5 = tmp_2 + tmp$ret$3 / b.f2().p1();
  return compareValues(tmp_1, tmp$ret$5);
}
function ContractorDashboard$renderMainContent$lambda_4($this$forEach, chunk) {
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().ig2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowCollapsingToColumn())($this$forEach.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs = $this$forEach.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
  $this$forEach.gbb(p, view);
  renderMainContent$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderSnapshot_mg9uce(view, getOrNull(chunk, 0));
  renderMainContent$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderSnapshot_mg9uce(view, getOrNull(chunk, 1));
  renderMainContent$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderSnapshot_mg9uce(view, getOrNull(chunk, 2));
  $this$forEach.hbb(p, view);
  return Unit_instance;
}
var ContractorDashboardClass;
function ContractorDashboard() {
  if (ContractorDashboardClass === VOID) {
    class $ {
      constructor() {
        this.tjg_1 = new (Constant())(_Constant___init__impl__v45mub('Home'));
      }
      wcv() {
        return this.tjg_1;
      }
      thi(_this__u8e3s4) {
        var isManager = remember(VOID, VOID, VOID, ContractorDashboard$renderMainContent$lambda);
        var contractor = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.daj($this$remember.daj(get_session()).lfv_1.geo($this$remember.daj(get_notNullContractor())));
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            get_pageNavigator(_this__u8e3s4).gbw(new (ClientDashboard())());
            throw CancellationException().ld('No Session Found');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var projectCondition = remember(VOID, VOID, VOID, ContractorDashboard$renderMainContent$lambda_0);
        var projectCount = rememberSuspending(VOID, VOID, VOID, ContractorDashboard$renderMainContent$slambda_0(projectCondition));
        var underEscrow = rememberSuspending(VOID, VOID, VOID, ContractorDashboard$renderMainContent$slambda_2(isManager, projectCondition));
        var availableCash = rememberSuspending(VOID, VOID, VOID, ContractorDashboard$renderMainContent$slambda_4(isManager));
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_dp(0));
        var tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        generalToDos(view_0);
        view_0.dbn(get_AppDimensions().bg2_1);
        title(view_0, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$1 = $this$reactiveScope.daj(contractor).v5i_1;
            this_0.set(tmp$ret$1);
            return Unit_instance;
          });
          return Unit_instance;
        });
        var tmp_1 = get_viewIsWide(view_0) ? get_padded(view_0) : Companion_getInstance_0();
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(true);
        view_2.bb9(get_AppDimensions().ag2_1);
        var tmp_2 = view_2.kbb(shownWhen(view_2, VOID, ($this$shownWhen) => $this$shownWhen.daj(isManager)), get_section(view_2));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(true);
        view_3.bb9(get_AppDimensions().zg1_1);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Account Overview';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.lba(view_4.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_3 = view_4.vb5_1;
        var tmp_4;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_4 = '\xA0';
        } else {
          tmp_4 = content;
        }
        tmp_3.hbu(tmp_4);
        view_3.hbb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().ig2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowCollapsingToColumn())(view_3.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_5 = view_3.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.gbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$9 = view_5.jbb(CardSemantic_getInstance());
        var tmp_5 = view_5.kbb(tmp$ret$9, get_expanding(view_5));
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Link())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.gbb(p_7, view_7);
        view_7.zbm(true);
        view_7.bb9(get_AppDimensions().zg1_1);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (TextView())(view_7.pc());
        var tmp0_elvis_lhs_8 = view_7.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
        view_7.gbb(p_8, view_8);
        view_8.lba(view_8.qb6_1.abf(SubtitleSemantic_getInstance()));
        view_8.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'Total Projects';
        var tmp_6 = view_8.vb5_1;
        var tmp_7;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_7 = '\xA0';
        } else {
          tmp_7 = value;
        }
        tmp_6.hbu(tmp_7);
        view_7.hbb(p_8, view_8);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (TextView())(view_7.pc());
        var tmp0_elvis_lhs_9 = view_7.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
        view_7.gbb(p_9, view_9);
        view_9.lba(view_9.qb6_1.abf(BodySemantic_getInstance()));
        view_9.dbs(Align_Center_getInstance());
        var tmp_8 = KMutableProperty0();
        var tmp_9 = TextView$_get_content_$ref_4pzcwl_0(view_9);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb_0(view_9));
        reactiveScope(view_9, ($this$reactiveScope) => {
          var tmp$ret$17 = $this$reactiveScope.daj(projectCount);
          this_0.set(tmp$ret$17);
          return Unit_instance;
        });
        view_7.hbb(p_9, view_9);
        view_6.hbb(p_7, view_7);
        view_6.kbw(ContractorDashboard$renderMainContent$lambda_1);
        view_5.hbb(p_6, view_6);
        view_5.lbb(tmp_5, view_6);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$31 = view_5.jbb(CardSemantic_getInstance());
        var tmp_10 = view_5.kbb(tmp$ret$31, get_expanding(view_5));
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Link())(view_5.pc());
        var tmp0_elvis_lhs_10 = view_5.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_5 : tmp0_elvis_lhs_10;
        view_5.gbb(p_10, view_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_11 = view_10.ebb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
        view_10.gbb(p_11, view_11);
        view_11.zbm(true);
        view_11.bb9(get_AppDimensions().zg1_1);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (TextView())(view_11.pc());
        var tmp0_elvis_lhs_12 = view_11.ebb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
        view_11.gbb(p_12, view_12);
        view_12.lba(view_12.qb6_1.abf(SubtitleSemantic_getInstance()));
        view_12.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_0 = 'Under Escrow';
        var tmp_11 = view_12.vb5_1;
        var tmp_12;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_0) === 0) {
          tmp_12 = '\xA0';
        } else {
          tmp_12 = value_0;
        }
        tmp_11.hbu(tmp_12);
        view_11.hbb(p_12, view_12);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (TextView())(view_11.pc());
        var tmp0_elvis_lhs_13 = view_11.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
        view_11.gbb(p_13, view_13);
        view_13.lba(view_13.qb6_1.abf(BodySemantic_getInstance()));
        view_13.dbs(Align_Center_getInstance());
        var tmp_13 = KMutableProperty0();
        var tmp_14 = TextView$_get_content_$ref_4pzcwl_1(view_13);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb_1(view_13));
        reactiveScope(view_13, ($this$reactiveScope) => {
          var tmp = $this$reactiveScope.daj(underEscrow);
          var tmp0_safe_receiver = tmp == null ? null : tmp.y5r_1;
          var tmp_0;
          var tmp_1 = tmp0_safe_receiver;
          if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
            tmp_0 = null;
          } else {
            tmp_0 = MonetaryValue__toString_impl_xslc77(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp_0;
          var tmp$ret$39 = tmp1_elvis_lhs == null ? 'N/A' : tmp1_elvis_lhs;
          this_1.set(tmp$ret$39);
          return Unit_instance;
        });
        view_11.hbb(p_13, view_13);
        view_10.hbb(p_11, view_11);
        view_10.kbw(ContractorDashboard$renderMainContent$lambda_2);
        view_5.hbb(p_10, view_10);
        view_5.lbb(tmp_10, view_10);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$53 = view_5.jbb(CardSemantic_getInstance());
        var tmp_15 = view_5.kbb(tmp$ret$53, get_expanding(view_5));
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (Link())(view_5.pc());
        var tmp0_elvis_lhs_14 = view_5.ebb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_5 : tmp0_elvis_lhs_14;
        view_5.gbb(p_14, view_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (RowOrCol())(view_14.pc());
        var tmp0_elvis_lhs_15 = view_14.ebb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
        view_14.gbb(p_15, view_15);
        view_15.zbm(true);
        view_15.bb9(get_AppDimensions().zg1_1);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (TextView())(view_15.pc());
        var tmp0_elvis_lhs_16 = view_15.ebb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
        view_15.gbb(p_16, view_16);
        view_16.lba(view_16.qb6_1.abf(SubtitleSemantic_getInstance()));
        view_16.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_1 = 'Available';
        var tmp_16 = view_16.vb5_1;
        var tmp_17;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_1) === 0) {
          tmp_17 = '\xA0';
        } else {
          tmp_17 = value_1;
        }
        tmp_16.hbu(tmp_17);
        view_15.hbb(p_16, view_16);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (TextView())(view_15.pc());
        var tmp0_elvis_lhs_17 = view_15.ebb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view_15 : tmp0_elvis_lhs_17;
        view_15.gbb(p_17, view_17);
        view_17.lba(view_17.qb6_1.abf(BodySemantic_getInstance()));
        view_17.dbs(Align_Center_getInstance());
        var tmp_18 = KMutableProperty0();
        var tmp_19 = TextView$_get_content_$ref_4pzcwl_2(view_17);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, TextView$_set_content_$ref_pketfb_2(view_17));
        reactiveScope(view_17, ($this$reactiveScope) => {
          var tmp = $this$reactiveScope.daj(availableCash);
          var tmp0_elvis_lhs = tmp == null ? null : tmp.y5r_1;
          var tmp_0;
          var tmp_1 = tmp0_elvis_lhs;
          if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
            tmp_0 = Companion_instance.r91(0n);
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var tmp$ret$61 = MonetaryValue__toString_impl_xslc77(tmp_0);
          this_2.set(tmp$ret$61);
          return Unit_instance;
        });
        view_15.hbb(p_17, view_17);
        view_14.hbb(p_15, view_15);
        view_14.kbw(ContractorDashboard$renderMainContent$lambda_3);
        view_5.hbb(p_14, view_14);
        view_5.lbb(tmp_15, view_14);
        view_3.hbb(p_5, view_5);
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_2, view_3);
        var tmp_20 = get_section(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_18 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_18 = view_2.ebb_1;
        var p_18 = tmp0_elvis_lhs_18 == null ? view_2 : tmp0_elvis_lhs_18;
        view_2.gbb(p_18, view_18);
        view_18.zbm(true);
        view_18.bb9(get_AppDimensions().zg1_1);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content_0 = 'Project Snapshots';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_19 = new (TextView())(view_18.pc());
        var tmp0_elvis_lhs_19 = view_18.ebb_1;
        var p_19 = tmp0_elvis_lhs_19 == null ? view_18 : tmp0_elvis_lhs_19;
        view_18.gbb(p_19, view_19);
        view_19.lba(view_19.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_21 = view_19.vb5_1;
        var tmp_22;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content_0) === 0) {
          tmp_22 = '\xA0';
        } else {
          tmp_22 = content_0;
        }
        tmp_21.hbu(tmp_22);
        view_18.hbb(p_19, view_19);
        var rawProjects = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).rfv_1;
          var tmp_0 = $this$remember.daj(projectCondition);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$88 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$88);
          this_0.m4a(get_state(it));
          this_0.k4a(get_name(it));
          var tmp$ret$93 = this_0.m1r();
          return $this$remember.daj(tmp.heo(new (Query())(tmp_0, tmp$ret$93)));
        });
        var lineItems = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.daj(rawProjects);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$94 = item.v7a_1;
            destination.v(tmp$ret$94);
          }
          var pids = destination;
          var tmp = $this$remember.daj(get_session()).ofv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$97 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$97);
          var tmp_1 = inside(get_project(it), pids);
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$102 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$102);
          var tmp$ret$106 = eq(get_cancelled(it_0), null);
          return $this$remember.daj(tmp.heo(new (Query())(And().v3q([tmp_1, tmp$ret$106]))));
        });
        var projects = remember(VOID, VOID, VOID, ($this$remember) => {
          var lineItems_0 = $this$remember.daj(lineItems);
          // Inline function 'kotlin.collections.associateWith' call
          var this_0 = $this$remember.daj(rawProjects);
          var result = LinkedHashMap().fc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
          // Inline function 'kotlin.collections.associateWithTo' call
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s_0 = lineItems_0.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              if (element.v7a_1.equals(element_0.f6k_1)) {
                destination.v(element_0);
              }
            }
            result.s3(element, destination);
          }
          // Inline function 'kotlin.collections.sortedBy' call
          var this_1 = toList(result.d2());
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp = ContractorDashboard$renderMainContent$lambda$lambda;
          var tmp$ret$113 = new (sam$kotlin_Comparator$0())(tmp);
          var tmp$ret$114 = sortedWith(this_1, tmp$ret$113);
          return chunked(tmp$ret$114, 3);
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_20 = new (RowOrCol())(view_18.pc());
        var tmp0_elvis_lhs_20 = view_18.ebb_1;
        var p_20 = tmp0_elvis_lhs_20 == null ? view_18 : tmp0_elvis_lhs_20;
        view_18.gbb(p_20, view_20);
        view_20.zbm(true);
        forEach(view_20, projects, ContractorDashboard$renderMainContent$lambda_4);
        view_18.hbb(p_20, view_20);
        view_2.hbb(p_18, view_18);
        view_2.lbb(tmp_20, view_18);
        view_1.hbb(p_2, view_2);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_1, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).dhg = get_requiredMembershipRole;
    protoOf($).fhg = get_awaitingApprovalMessage;
    protoOf($).ghg = renderFinishRegistration;
    protoOf($).hhg = renderAwaitingApproval;
    protoOf($).wd6 = render;
    initMetadataForClass($, 'ContractorDashboard', ContractorDashboard, VOID, [ContractorPage()]);
    ContractorDashboardClass = $;
  }
  return ContractorDashboardClass;
}
//region block: exports
export {
  ContractorDashboard as ContractorDashboardpd20b7ol1l5h,
};
//endregion

//# sourceMappingURL=ContractorDashboard.mjs.map
